var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { useTheme } from '@xstyled/styled-components';
import { th } from '@xstyled/system';
var StyledHighlightBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: ml;\n  font-size: 12px;\n  text-align: center;\n  line-height: 19.2px;\n  min-width: 0;\n  font-weight: semiBold;\n  .default {\n    height: 24px;\n    padding: 2px 8px !important;\n  }\n  .small {\n    height: 18px;\n    padding: 1px 6px;\n  }\n  .wide {\n    height: 2.75em;\n    display: flex;\n    flex-flow: row wrap;\n    width: 11rem;\n    align-content: center;\n    line-height: 14px;\n    padding: 0.5px 12px;\n  }\n  .fitContent {\n    width: fit-content;\n    height: auto;\n    padding: 4px 5px;\n    font-size: 13px;\n    line-height: 15px;\n    font-weight: 400;\n  }\n  background-color: ", ";\n  color: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: ml;\n  font-size: 12px;\n  text-align: center;\n  line-height: 19.2px;\n  min-width: 0;\n  font-weight: semiBold;\n  .default {\n    height: 24px;\n    padding: 2px 8px !important;\n  }\n  .small {\n    height: 18px;\n    padding: 1px 6px;\n  }\n  .wide {\n    height: 2.75em;\n    display: flex;\n    flex-flow: row wrap;\n    width: 11rem;\n    align-content: center;\n    line-height: 14px;\n    padding: 0.5px 12px;\n  }\n  .fitContent {\n    width: fit-content;\n    height: auto;\n    padding: 4px 5px;\n    font-size: 13px;\n    line-height: 15px;\n    font-weight: 400;\n  }\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
    var $bgcolor = _a.$bgcolor;
    return $bgcolor;
}, function (_a) {
    var $fontColor = _a.$fontColor;
    return $fontColor;
});
var OverflowWrap = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])));
export var flagAppearanceToColorMap = {
    neutralBold: 'neutral300',
    neutralSubtle: 'neutral20',
    blueBold: 'blue70',
    blueSubtle: 'blue20',
    tealBold: 'teal60',
    tealSubtle: 'teal20',
    greenBold: 'green60',
    greenSubtle: 'green20',
    orangeBold: 'orange60',
    orangeSubtle: 'orange20',
    yellowBold: 'yellow60',
    yellowSubtle: 'yellow20',
    pinkBold: 'magenta60',
    pinkSubtle: 'magenta20',
    purpleBold: 'purple60',
    purpleSubtle: 'purple20',
    redBold: 'red60',
    redSubtle: 'red20',
};
export var flagAppearanceToFontColorMap = {
    neutralBold: 'white',
    neutralSubtle: 'typoPrimary',
    blueBold: 'white',
    blueSubtle: 'blue80',
    tealBold: 'white',
    tealSubtle: 'teal90',
    greenBold: 'white',
    greenSubtle: 'green80',
    orangeBold: 'white',
    orangeSubtle: 'orange80',
    yellowBold: 'typoPrimary',
    yellowSubtle: 'typoPrimary',
    pinkBold: 'white',
    pinkSubtle: 'magenta80',
    purpleBold: 'white',
    purpleSubtle: 'purple80',
    redBold: 'white',
    redSubtle: 'red80',
};
var HighlightBox = function (_a) {
    var children = _a.children, appearance = _a.appearance, _b = _a.size, size = _b === void 0 ? 'default' : _b, className = _a.className, prefix = _a.prefix;
    var theme = useTheme();
    var bgColor = th.color(appearance ? flagAppearanceToColorMap[appearance] : 'transparent')({ theme: theme });
    var fontColor = th.color(appearance ? flagAppearanceToFontColorMap[appearance] : 'typoPrimary')({ theme: theme });
    var name = !!prefix ? "".concat(prefix, "Label") : 'label';
    return (_jsx(StyledHighlightBox, { "$bgcolor": bgColor, "$fontColor": fontColor, "data-cy": name, children: _jsx(OverflowWrap, { className: size + ' ' + className, children: children }) }));
};
export default HighlightBox;
var templateObject_1, templateObject_2;
